import { useEffect, useState } from 'preact/hooks'
import { login } from '@/core'
import { fetchUserInfo } from '@u/drf/auth'

export function useSamlBootstrap(store) {
  const [booted, setBooted] = useState(false)

  const logoutCheck = () => {
    const token = localStorage?.getItem('token')
    const users = localStorage?.getItem('users')
    if (token && !users) {
      window.localStorage.clear()
      const base = `${window.location.protocol}//${window.location.host}`
      window.location.assign(`${base}/v2/login`)
    }
  }

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const url = new URL(window.location.href)
        const token = url.searchParams.get('auth_token')
        const samlLogin = url.searchParams.get('saml_login')

        if (token && samlLogin) {
          localStorage.setItem('token', token)

          const info = await fetchUserInfo({ token })
          if (!cancelled) {
            await login(store, { token, info })
            const clean = url.origin + url.pathname + url.hash
            window.history.replaceState({}, '', clean)
          }
        }
      } catch (e) {
        console.error('SAML bootstrap failed', e)
      } finally {
        if (!cancelled) {
          logoutCheck()
          setBooted(true)
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return { booted }
}
